var collapsible_list_pair_rtlignore_default = {
  "container": "VPKx6",
  "title": "sXzLg",
  "viewerContainer": "_6pwzO",
  "titleContainer": "F9ZPG",
  "content": "UedAH",
  "expandIcon": "fMNQC",
  "dndIcon": "B73KK",
  "RTL": "ul9Aa",
  "LTR": "OJEt7",
  "itemContainer": "Af82E",
  "itemContainerViewer": "z0QdS",
  "mouseDown": "c3fk-",
  "innerEditor": "cys5S",
  "item": "_9inY-",
  "floatingAddPluginMenuWrapper": "Gp02q"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
